export default __webpack_public_path__ + "static/media/groupIcon.d7fb0722.svg";